<template>
  <p>
    <span v-if="!show">{{truncate(text)}} <a href="javascript:;" v-if="text.length >= length" @click="toggle()">{{clamp}}</a></span>
    <span v-if="show">{{text}} <a href="javascript:;" @click="toggle()" v-if="text.length >= length">{{less}}</a></span>
  </p>
</template>

<script>
  export default {
    props: {
      text: {},
      clamp: {
        default: 'Read More'
      },
      less: {
        default: 'Read Less'
      },
      length: {
        default: 100
      }
    },
    methods: {
      truncate(string) {
        if (string) {
          return string.toString().substring(0, this.length);
        }

        return '';
      },
      toggle() {
        this.show = !this.show;
      },
    },
    data() {
      return {
        show: false
      };
    },
  }
</script>